
<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{parentData.title}} [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <!-- <mat-form-field appearance="outline" class="me-2" *ngIf="toShowInventoryItems || toShowInventoryTemplate">
        <mat-label>{{ 'services.label' | translate }}</mat-label>
        <input
        [formControl]="searchString"
         
          matInput
          placeholder="{{ 'services.placeholder' | translate }}"
          (keyup)="searchServiceData()"
        />
        <button
        
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon >close</mat-icon>
      </button>
      </mat-form-field> -->

      <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>
</sm-misc-title-bar>
<div class="ivbentypr_item">
<mat-form-field appearance="outline" class="me-2" *ngIf="toShowInventoryItems || toShowInventoryTemplate">
  <mat-label>{{ 'services.label' | translate }}</mat-label>
  <input
  [formControl]="searchString"
   
    matInput
    placeholder="{{ 'services.placeholder' | translate }}"
    (keyup)="searchServiceData()"
  />
  <button
  
    mat-button
    *ngIf="!searchString.value"
    matSuffix
    
    aria-label="Clear"
  >
    <mat-icon>search</mat-icon>
  </button>
  <button
  mat-button
  *ngIf="searchString.value"
  matSuffix
  
  aria-label="Clear"
  (click)="reset()"
>
  <mat-icon >close</mat-icon>
</button>
</mat-form-field>
</div>
<!-- inventory increase/decrease modal -->
  <mat-dialog-content *ngIf="!toShowInventoryItems && !toShowInventoryTemplate && (operation_type == 1 || operation_type == 2)"  >
    <div class="text-fieldss">
      <h3 style="    font-weight: 700;
      margin-bottom: 5px;">{{selectedInventoryData[0].item_name}}</h3>
      <!-- <p>{{selectedInventoryData[0].quantity_info}}</p> -->
      <p>Current stock: <strong>{{selectedInventoryData[0].current_purchase_stock}} {{selectedInventoryData[0].purchase_unit}}</strong> </p>
      <p>Minimum stock: <strong> {{selectedInventoryData[0].min_stock}} {{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p>Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p *ngIf="selectedInventoryData[0].selling_unit != selectedInventoryData[0].purchase_unit">Selling unit: <strong>{{selectedInventoryData[0].selling_unit}}</strong></p>
    </div>

    <div class="text-fieldss d-flex align-items-baseline" >
      <mat-form-field appearance="outline">
        <mat-label>{{operation_type == 1 ? 'Quantity to increase' : 'Quantity to decrease'}}</mat-label>
        <input smNumericOnly
          [(ngModel)]="inventoryListData.qty"
          matInput

        />
       
      </mat-form-field>
      <span style="margin-left: 10px;" *ngIf="selectedInventoryData[0].selling_unit == selectedInventoryData[0].purchase_unit">{{selectedInventoryData[0].purchase_unit}}</span>
      <!-- <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p style="position: relative; top: -10px;">Selling unit: <strong>{{selectedInventoryData[0].selling_unit}}</strong></p> -->
    </div>
     <div style="margin-bottom: 10px;" *ngIf="selectedInventoryData[0].selling_unit != selectedInventoryData[0].purchase_unit">
        <!-- <mat-label></mat-label> -->
        <!-- <br><br> -->


        <input type="radio" id="selling" name="unit" value="1" (click)="discType($event)">
        <label for="selling" class="radlabel">{{selectedInventoryData[0].selling_unit}}</label>
        <input type="radio" id="purchase" name="unit" value="2" (click)="discType($event)">
        <label for="purchase" class="radlabel">{{selectedInventoryData[0].purchase_unit}}</label>

    </div>

    <div class="text-fieldss">
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea
          [(ngModel)]="inventoryListData.notes"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div class="text-fieldss">
      <mat-form-field appearance="outline">
        <mat-label>Barcode</mat-label>
        <input
          [(ngModel)]="inventoryListData.barcode"
          matInput
        />
       
      </mat-form-field>
    </div>
    
   
  </mat-dialog-content>

  <!-- new inventory item add modal -->
  <mat-dialog-content *ngIf="(!toShowInventoryItems && !toShowInventoryTemplate && operation_type == 3) || showInventoryAdd" >
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Item name</mat-label>
        <input
          
          [(ngModel)]="newInventoryData.item_name"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Item description</mat-label>
        <textarea
          [(ngModel)]="newInventoryData.item_desc"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div style="margin-top: 10px;">
      <mat-form-field appearance="outline">
        <mat-label>Purchase unit</mat-label>
        <input
          [(ngModel)]="newInventoryData.purchase_unit"
          matInput
        />
        <mat-hint align="start">Example: carton or kg or bottle etc</mat-hint>
      </mat-form-field>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <mat-checkbox value="shop" (change)="change($event)" [checked]="newInventoryData.for_sale == 1"></mat-checkbox>
      <mat-label >Item for sale</mat-label>

    </div>
    
    <div *ngIf="newInventoryData.for_sale == 1" style="margin-bottom: 10px;">
      <mat-form-field appearance="outline">
        <mat-label>Selling unit</mat-label>
        <input
        [(ngModel)]="newInventoryData.selling_unit"
        matInput
        />
        <mat-hint align="start">Example: sachet or gm or ml etc</mat-hint>
      </mat-form-field>
    </div>
    <div *ngIf="newInventoryData.for_sale == 1">
      <mat-form-field appearance="outline">
        <mat-label>Selling quantity</mat-label>
        <input
          [(ngModel)]="newInventoryData.qty_info" smDecimalOnly  type="number"
          matInput
        />
        <!-- <mat-hint align="start">Example: 100 ml bottle or 500 gm pack etc</mat-hint> -->
      </mat-form-field>
    </div>

    <div style="margin-top: 20px;margin-bottom: 5px;" class="d-flex align-items-center" *ngIf="newInventoryData.for_sale == 1 && newInventoryData.selling_unit != newInventoryData.purchase_unit">
        <!-- <mat-form-field appearance="outline" style="width: 25%;"> -->
        <!-- <label>Purchase unit</label> -->
        <input smDecimalOnly  type="number"
          style="border-radius: 3px;border: 1px solid #c9c9c9;width: 75px;margin-right:10px;text-align: center;height: 35px;"
          [(ngModel)]="newInventoryData.selling_purchase_multiplier"
          matInput
        />
      <!-- </mat-form-field> -->
      <span [ngClass]="{'make-txt-grey': !newInventoryData.selling_unit}">{{newInventoryData.selling_unit ? newInventoryData.selling_unit : 'Selling unit'}}</span>
      <span style="margin-left: 5px; margin-right: 5px;"> =</span> 1 <span style="margin-left: 5PX;" [ngClass]="{'make-txt-grey': !newInventoryData.purchase_unit}">{{newInventoryData.purchase_unit ? newInventoryData.purchase_unit : 'Purchase unit'}}</span><br>
    </div>
    <mat-hint align="start" style="font-size: 75%;" *ngIf="newInventoryData.for_sale == 1 && newInventoryData.selling_unit != newInventoryData.purchase_unit">Example: 100 sachet = 1 carton or 1000gm = 1kg</mat-hint>


  <div class="">
    <div style="margin-top: 20px; " class="d-flex align-items-center">
      <div style="margin-right: 10px;" class="w-100">
        <mat-form-field appearance="outline">
          <mat-label>Minimum stock</mat-label>
          <input smNumericOnly
          [(ngModel)]="newInventoryData.min_stock"
          matInput/>
          
        </mat-form-field>
      </div>
      <span style="position: relative;top: -9px;  display: block;">{{newInventoryData.purchase_unit}}</span>
    </div>
    </div>
     <div class="">
    <div style="margin-top: 20px; " class="d-flex align-items-center">
      <div style="margin-right: 10px;" class="w-100">
        <mat-form-field appearance="outline">
          <mat-label>Current stock</mat-label>
          <input smNumericOnly [disabled]="editMode"
            [(ngModel)]="newInventoryData.current_stock"
            matInput
  
          />
         
        </mat-form-field>
      </div>
      <span style="    position: relative; display: block;
    top: -9px;">{{newInventoryData.purchase_unit}}</span>

    </div>
    </div>

    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>

  <!-- inventory items -->
  <mat-dialog-content *ngIf="toShowInventoryItems" style="min-width: 80vw;">
    <div class="row" *ngIf="inventoryItems.length>0">
        <div class="col-sm-4" *ngFor="let item of inventoryItems">
            <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                <div class="top_section_order">
                    <div class="row">
                         <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                             <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff; font-size: 24px">check</mat-icon>
                          </div>
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                    <img [src]="item.image_thumb_url">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                             
                                <h3>{{item.item_name}}</h3>
                                <p class="elips_cls">{{
                                  item.item_desc
                                }}
                                </p>
                            
                                <!-- <p>Quantity info: {{item.quantity_info}}
                                </p> -->
                              
                             </div>
                        </div>
                    </div>
                      <div class="addmore_btn" *ngIf="item.selected">
                        <button mat-flat-button color="accent" (click)="onSelectNext()"><mat-icon>add</mat-icon>  Add this </button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="datalength > inventoryItems.length" style="text-align: center;">
          <button
          style="
          width: 50%;
          border-radius: 50px;"
      mat-flat-button
      color="accent"
      (click)="seeMore()"
    >
      See more
    </button>
   
        </div>
        

    </div>
    <div class="row" *ngIf="inventoryItems.length == 0 && loading">
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <p>Loading Inventory Items</p>
      </div>
    </div>
    <div class="row" *ngIf="inventoryItems.length == 0 && !loading" >
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <div style="margin-bottom: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><switch><g><path d="M100.5 512c-13.81.001-25.416-10.824-26.205-24.779L52.429 100.43c-.396-7.003 1.959-13.742 6.632-18.974 4.672-5.232 11.103-8.332 18.105-8.728l39.094-2.21V26.261C116.26 11.781 128.04 0 142.521 0h256.382c1.334 0 2.613.533 3.553 1.481l55.711 56.252a5.003 5.003 0 0 1 1.447 3.519v373.692a5 5 0 0 1-5 5H415.52l2.776 49.124a5 5 0 0 1-4.71 5.274l-311.589 17.615c-.5.029-1 .043-1.497.043zm15.76-431.466-38.529 2.178a16.156 16.156 0 0 0-11.212 5.404 16.15 16.15 0 0 0-4.105 11.749L84.28 486.656c.506 8.952 8.216 15.827 17.153 15.317L408.03 484.64l-2.526-44.696H142.521c-14.48 0-26.261-11.78-26.261-26.261zM142.521 10c-8.966 0-16.261 7.295-16.261 16.261v387.422c0 8.966 7.295 16.261 16.261 16.261h307.093V66.252h-45.035c-5.887 0-10.676-4.789-10.676-10.675V10zm261.382 7.154v38.423c0 .372.303.675.676.675h38.046zm-161.876 358h-43.042c-10.387 0-18.837-8.45-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.838 8.837 8.838h43.042c4.873 0 8.838-3.965 8.838-8.838v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.404H287.541c-2.762 0-5-2.238-5-5s2.238-5 5-5h103.186c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-175.524-3.183a4.983 4.983 0 0 1-3.479-1.409l-7.845-7.599a5 5 0 0 1-.111-7.069 4.998 4.998 0 0 1 7.069-.112l4.338 4.202 14.971-14.73a4.998 4.998 0 0 1 7.071.058 5 5 0 0 1-.058 7.071l-18.45 18.153a4.99 4.99 0 0 1-3.506 1.435zm115.424-21.335h-43.086c-2.762 0-5-2.238-5-5s2.238-5 5-5h43.086c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.403H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.182a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.336h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.837V83.627c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.387-8.451 18.838-18.838 18.838zm-43.042-64.288c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837V83.627c0-4.873-3.965-8.837-8.838-8.837h-43.042zM390.727 119.1H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.089a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.242h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10z" fill="#7e7e7e" opacity="1" data-original="#000000"></path></g></switch></g></svg>
        </div>
        <p>No inventory items to show</p>
      </div>
    </div>
  </mat-dialog-content>
  <!-- inventory items template -->
  <mat-dialog-content *ngIf="toShowInventoryTemplate" style="min-width: 80vw;">
    <div class="row" *ngIf="inventoryTemplateData.length>0">
        <div class="col-sm-4" *ngFor="let item of inventoryTemplateData">
            <div class="fl_orders" (click)="selectInventoryTemplateDataByKeyword(item)">
                <div class="top_section_order">
                    <div class="row">
                         <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff; font-size: 24px" >check</mat-icon>
                                </div>
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                    <img [src]="item.image_thumb_url">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                             
                                <h3>{{item.item_name}}</h3>
                                <p class="elips_cls">{{
                                  item.item_desc
                                }}
                                </p>
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <!-- <p>Quantity info: {{item.quantity_info}}
                                </p> -->
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                      <div class="addmore_btn" *ngIf="item.selected">
                        <button mat-flat-button color="accent" (click)="onSelectNextOnTemplateData()"><mat-icon>add</mat-icon>  Add this </button>
                    </div>
                </div>
            </div>
        </div>
        

        <div *ngIf="datalength > inventoryTemplateData.length" style="text-align: center;">
          <button
           style="
          width: 50%;
          border-radius: 50px;"
       mat-flat-button
      color="accent"
      (click)="seeMore()" >
      See more
    </button>
        </div>

    </div>
    <div class="row" *ngIf="loading">
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <p>Loading Inventory Templates</p>
      </div>
    </div>
    <div class="row" *ngIf="inventoryTemplateData.length == 0 && !loading">
      <!-- <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <p>No inventory templates to show</p>
      </div> -->
        <div class="inven_sde loading_invoice" style="padding: 50px 0px; text-align: center;">
         <div class="bener_list">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><switch><g><path d="M100.5 512c-13.81.001-25.416-10.824-26.205-24.779L52.429 100.43c-.396-7.003 1.959-13.742 6.632-18.974 4.672-5.232 11.103-8.332 18.105-8.728l39.094-2.21V26.261C116.26 11.781 128.04 0 142.521 0h256.382c1.334 0 2.613.533 3.553 1.481l55.711 56.252a5.003 5.003 0 0 1 1.447 3.519v373.692a5 5 0 0 1-5 5H415.52l2.776 49.124a5 5 0 0 1-4.71 5.274l-311.589 17.615c-.5.029-1 .043-1.497.043zm15.76-431.466-38.529 2.178a16.156 16.156 0 0 0-11.212 5.404 16.15 16.15 0 0 0-4.105 11.749L84.28 486.656c.506 8.952 8.216 15.827 17.153 15.317L408.03 484.64l-2.526-44.696H142.521c-14.48 0-26.261-11.78-26.261-26.261zM142.521 10c-8.966 0-16.261 7.295-16.261 16.261v387.422c0 8.966 7.295 16.261 16.261 16.261h307.093V66.252h-45.035c-5.887 0-10.676-4.789-10.676-10.675V10zm261.382 7.154v38.423c0 .372.303.675.676.675h38.046zm-161.876 358h-43.042c-10.387 0-18.837-8.45-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.838 8.837 8.838h43.042c4.873 0 8.838-3.965 8.838-8.838v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.404H287.541c-2.762 0-5-2.238-5-5s2.238-5 5-5h103.186c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-175.524-3.183a4.983 4.983 0 0 1-3.479-1.409l-7.845-7.599a5 5 0 0 1-.111-7.069 4.998 4.998 0 0 1 7.069-.112l4.338 4.202 14.971-14.73a4.998 4.998 0 0 1 7.071.058 5 5 0 0 1-.058 7.071l-18.45 18.153a4.99 4.99 0 0 1-3.506 1.435zm115.424-21.335h-43.086c-2.762 0-5-2.238-5-5s2.238-5 5-5h43.086c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.403H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.182a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.336h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.837V83.627c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.387-8.451 18.838-18.838 18.838zm-43.042-64.288c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837V83.627c0-4.873-3.965-8.837-8.838-8.837h-43.042zM390.727 119.1H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.089a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.242h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10z" fill="#7e7e7e" opacity="1" data-original="#000000"></path></g></switch></g></svg>
          </div>
         <p>No inventory templates to show</p>
        </div>
    </div>
  </mat-dialog-content>
  
  <!-- buttons when showing adding new inventory modal -->
  <mat-dialog-actions align="end" *ngIf="(!toShowInventoryItems && !toShowInventoryTemplate && operation_type == 3) || showInventoryAdd">
    <button mat-button mat-dialog-close *ngIf="!showInventoryAdd">Cancel</button>
    <button mat-button (click)="backFromInventoryTemplate()" *ngIf="showInventoryAdd">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !newInventoryData.item_name 
      "
      (click)="onAddEditInventoryItem()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>
  <!-- buttons when showing increase/decrease modal -->
  <mat-dialog-actions align="end" *ngIf="!toShowInventoryItems && !toShowInventoryTemplate && (operation_type == 1 || operation_type == 2)">
    <button mat-button (click)="back()">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !inventoryListData.qty || inventoryListData.qty == '' || !typeofactivity
      "
      (click)="onPost()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>


  